import {Bullet} from 'commons/models';

export const data: Array<Bullet> = [
    {
        desc: '',
        items: [
            {
                item: 1,
                sections: [
                    {
                        value: 'Alinea el documento/identificaci\u00F3n a las gu\u00EDas.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 2,
                sections: [
                    {
                        value: 'Captura el documento original (no uses copias).',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 3,
                sections: [
                    {
                        value: 'La imagen deber\u00E1 ser a color.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
            {
                item: 4,
                sections: [
                    {
                        value: 'La imagen debe contrar con un fondo claro y buena iluminaci\u00F3n.',
                        style: 'body',
                        order: 0,
                    },
                ],
            },
        ],
    },
];
